import { render, staticRenderFns } from "./AdminPlanDelete.vue?vue&type=template&id=f27a0c76"
import script from "./AdminPlanDelete.vue?vue&type=script&lang=js"
export * from "./AdminPlanDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports